import ReactDOM  from "react-dom";
import Router from './router';
import {Provider} from 'react-redux'
import store from './store'
import "./assets/css/input.css"
import "./assets/css/base.less"
import Loading from './components/loading/Loading';




// import Vconsole from 'vconsole'
 

import './locales/i18n';

// const vConsole = new Vconsole()



ReactDOM.render(
    <Provider store={store}>
       
        <Loading/>
      
            <Router/>
     
        
        
    </Provider>
    ,
    document.getElementById("root")
)